<template>
  <div :data-test-id="dataTestId">
    <ReviewSummary
      :reviewSummaries="fields.items"
      :isConfirmationStep="false"
      :disableExpandToggle="false"
      :showDiscounts="true"
      :title="fields.title"
      :isSelfService="true"
      :heading="fields.heading"
      :belowHeading="fields.belowHeading"
      :subheading="fields.subheading"
    />
  </div>
</template>

<script setup lang="ts">
import { ComponentFields, ComponentRendering } from '@sitecore-jss/sitecore-jss/types/layout';
import ReviewSummary from './ReviewSummary.vue';
import { usePageStore } from '@/store';

// ----------------------------------------------------------------------------------
// Define variables
// ----------------------------------------------------------------------------------
const props = defineProps<{
  fields?: ComponentFields;
  rendering?: ComponentRendering;
}>();

const dataTestId = usePageStore().dataTestId(props.rendering);
</script>
